






















export default

	computed:
		navigationData: -> @$store.state.globals.footerNavigation?.menuLinks

